import React, { useEffect, useState } from "react";
import { SpinnerBlock } from "../../../../Utils/CustomComponent";
import { useDispatch, useSelector } from "react-redux";
import { useAbortController } from "../../../../hooks/useAbortController";
import { loadingTypes } from "../../../../Utils/constant";
import { fetchBorrowerOneTimePaymentsHistory } from "../../../../store/reducers/dashboardSlice/api";
import CommonGrid from "../../../../components/CommonGrid";
import { gridColumns_OneTimePastPayments } from "../../../../Utils/TableColumnDefs";

const headers = {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  },
};

const OneTimePastPayments = () => {
  const [loading, setLoading] = useState(false);

  const data = useSelector(
    (state) => state.dashboard.borrowerOneTimePaymentsHistory.data
  );
  const status = useSelector(
    (state) => state.dashboard.borrowerOneTimePaymentsHistory.status
  );
  const dispatch = useDispatch();
  const { signal } = useAbortController();

  const userId = localStorage.getItem("apex_userid");

  useEffect(() => {
    if (status === loadingTypes.idle && userId && !loading) {
      dispatch(
        fetchBorrowerOneTimePaymentsHistory({
          userId,
          headers,
          signal,
        })
      );

      setLoading(true);
    }
  }, [status, dispatch, userId, loading]);

  //   useEffect(() => {
  //     dispatch(
  //       fetchBorrowerOneTimePaymentsHistory({
  //         userId,
  //         headers,
  //         signal,
  //       })
  //     );
  //   }, []);

  return (
    <div className="col-md-12 col-sm-12 border border-primary p-3">
      <CommonGrid
        gridColumns={gridColumns_OneTimePastPayments}
        title="Past One Time Payments"
        columnData={data}
        header={false}
        minHeight={"100%"}
        tHeight={""}
        tableTotal={["amount"]}
        showTotal={true}
        status={status}
      />
      {/* <h6>Past One Time Payments</h6> */}
      {/* <div style={{ maxHeight: "50vh", overflow: "auto" }}>
        <table style={styles.container}>
          <thead>
            <tr>
              <th style={styles.th} className="bg-primary text-white">
                Loan Account
              </th>
              <th style={styles.th} className="bg-primary text-white">
                Amount
              </th>
              <th style={styles.th} className="bg-primary text-white">
                Date Issued
              </th>
              <th style={styles.th} className="bg-primary text-white">
                Cheque Number
              </th>
            </tr>
          </thead>
          <tbody>
            {status === loadingTypes.fulfilled ? (
              data?.length ? (
                data.map((el) => (
                  <tr key={el.cheque_number}>
                    <td style={styles.td}>{el.loan_account_number}</td>
                    <td style={styles.td}>${el.amount.toFixed(2)}</td>
                    <td style={styles.td}>{el.date_issued}</td>
                    <td style={styles.td}>{el.cheque_number}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={styles.td} className="text-center" colSpan={4}>
                    No One Time Payments History
                  </td>
                </tr>
              )
            ) : status === loadingTypes.loading ? (
              <div>
                <SpinnerBlock height="10vh" />{" "}
              </div>
            ) : null}
          </tbody>
        </table>
      </div> */}
    </div>
  );
};

export default OneTimePastPayments;

const styles = {
  container: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  },
  th: {
    textAlign: "left",
    backgroundColor: "#f0f0f0",
    padding: "10px",
    border: "1px solid black",
  },
  td: {
    padding: "10px",
    border: "1px solid black",
  },
};
